import React, { useState, useEffect } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import InputBase from '@material-ui/core/InputBase';
import { Box, Grid, Button, List, ListItem, Collapse } from '@material-ui/core';
import icAlert from '../assets/icons/white-information-circle.png';
import icWindowApp from '../assets/icons/white-app-window-add.png';
import icConfig from '../assets/icons/white-cog.png';
import icEmail from '../assets/icons/white-email-action-send.png';
import icScreen from '../assets/icons/white-screen.png';
import icSearch from '../assets/icons/grayscale-3-search.png'
import {
    usePopupState,
    bindToggle,
} from 'material-ui-popup-state/hooks'
import CustomPopoverArrow from '../CustomizedUIs/CustomPopoverArrow'
import { useMediaQuery, Dialog, IconButton } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { darkTheme, lightTheme } from '../layout/themes';
import SubItem from './SubItem'
import { Link, useHistory, useLocation } from "react-router-dom";
import { useTranslate, Title, useDataProvider, Loading, usePermissions } from 'react-admin';
import Error from '../CustomizedUIs/Error'
import IconRadiusButton from '../CustomizedUIs/IconRadiusButton';
import colors from '../CustomizedUIs/Colors'
import CreateRoomDialog from './CreateRoomDialog';
import EditClusterDialog from './EditClusterDialog'
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import EditRoomDialog from './EditRoomDialog';
import Tooltip from '@material-ui/core/Tooltip';
import Zoom from '@material-ui/core/Zoom';
import GreenSwitch from '../CustomizedUIs/GreenSwitch';
import CreateMessageDialog from '../message/dialog-send-message';
import CreateAlarmDialog from '../alarm/dialog-send-message';
import Arrow from '../assets/icons/white-arrow-left.png';
import { MESSAGES_TYPE } from '../utils';
import DialogSendSuccess from '../common/dialog-send-success';
import ArrowRight from '@material-ui/icons/ArrowRight';
import { cloneDeep } from 'lodash';
import GoBackButton from '../CustomizedUIs/GoBackButton';
import DialogChooseInfoPage from '../common/dialog-choose-info-page';
import InfoIcon from '@material-ui/icons/Info';

const paleOlive = '#bbd593';
const greyBlue = '#6cb5b8';
const customRed = '#e1503a';
const turQuoise = '#62bfd5';
const darkFuchsia = '#b21280';
let _intervalUpdateStatus = null;


const CustomTooltip = withStyles((theme) => ({

    arrow: {
        fontSize: 8,
    }
}))(Tooltip);

const useStyles = makeStyles(theme => ({
    searchPaper: {
        padding: '4px 2px',
        display: 'flex',
        alignItems: 'center',
        margin: 'auto 0',
        boxShadow: 'none',
        width: 236
    },
    input: {
        marginLeft: theme.spacing(1),
        flex: 1,
        width: 236,
        fontFamily: 'UniviaPro-Book',
        fontSize: '12px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: 'normal',
        color: '#88898c',
        '&::placeholder': {
            color: '#88898c',
            opacity: 1
        }

    },
    backdrop: {
        zIndex: 100000,
        color: '#fff',
    },
    arrow: {
        fontSize: 12,
        color: 'white',
    },
    buttonIcon: {
        padding: '10px 15px 9px 15px',
        marginRight: 8,
        fontFamily: 'UniviaPro-Bold',
        fontSize: '9px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.22,
        letterSpacing: '0.36px',
        color: ' #ffffff',
    },
    floorLocation: {
        fontSize: 14,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 2.14,
        color: '#4f5064',
        letterSpacing: 0.15,
        fontFamily: 'UniviaPro-Medium',
        fontWeight: '500',
        marginBottom: 7
    },
    group: {
        fontFamily: 'UniviaPro-Medium',
        fontSize: '18px',
        fontWeight: 500,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.2,
        letterSpacing: 'normal',
        color: '#4f5064',
    },
    textExpand: {
        fontFamily: 'UniviaPro-Bold',
        fontSize: '9px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.22,
        letterSpacing: '0.36px',
        color: '#4f5064',
        padding: '5px 8px 5px 8px'
    },
    TextIcon: {
        fontFamily: 'UniviaPro-Medium',
        fontSize: '10px',
        fontWeight: 500,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: '0.2px',
        color: '#88898c',
    },
    TextRoom: {
        fontFamily: 'UniviaPro',
        fontSize: '12px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: '1.6',
        letterSpacing: '0.5px',
        color: '#4f5064',
    },
    TextID: {
        fontFamily: 'UniviaPro-Medium',
        fontSize: '10px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: '0.25px',
        color: '#4f5064',
    },
    borderRoom: {
        borderRadius: '6px',
        backgroundColor: '#f7f7f7'
    },
    border: {
        borderRadius: '2px',
        backgroundColor: '#f3f7fa',
    },
    HeaderBack: {
        fontFamily: 'UniviaPro-Medium',
        fontSize: '15px',
        fontWeight: 500,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.2,
        letterSpacing: 'normal',
        color: theme.palette.primary.main,
    },

    TextDivices: {
        fontFamily: 'UniviaPro',
        fontSize: '12px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: '1.6',
        letterSpacing: '0.5px',
        color: '#ffffff',
    },
    textTab: {
        fontSize: 13,
        color: '#4f5064',
        fontFamily: 'UniviaPro',
        fontWeight: 'normal',
        letterSpacing: '0.13px',
        lineHeight: '16.3px',
        fontStyle: 'normal',
        fontStretch: 'normal',
        padding: '5px'
    }


}))

// TODO: ROOM
const RoomItem = ({ filter, arrayData, showId, row, clusterData, roomOnClick, permissions, device }) => {
    const classes = useStyles();
    const dataProvider = useDataProvider();
    const history = useHistory()
    const location = useLocation()
    const [devices, setDevices] = React.useState(row.devices)
    const [dialogSuccessMessage, setDialogSuccessMessage] = useState('');

    //console.log(filter)
    // const getStatus = () => {
    //     var temps = row.devices.slice()
    //     var arrayMac = []
    //     row.devices.forEach((value) => {
    //         arrayMac.push(value.id)
    //     })
    //     arrayMac.length > 0 &&
    //         dataProvider('CREATE', "devices/getstatus", {
    //             data: {
    //                 macs: arrayMac
    //             }
    //         }).then(({ data }) => {
    //             data.forEach((item, index) => {
    //                 const device = temps.find((devices) => devices.id === item.macAddress);
    //                 // console.log(device, "device")
    //                 // console.log(temps[index], "temps[index]")
    //                 switch (item.status) {
    //                     case 1:
    //                         temps[index].status = customRed
    //                         break;
    //                     case 2://VOD
    //                         temps[index].status = greyBlue
    //                         break;
    //                     case 3://TV
    //                         temps[index].status = paleOlive
    //                         break;
    //                     case 4://Menu
    //                         temps[index].status = turQuoise
    //                         break;
    //                     case 5://IC
    //                         temps[index].status = darkFuchsia
    //                         break;

    //                     default:
    //                         temps[index].status = customRed

    //                 }
    //             })
    //             setDevices(temps)
    //             // .catch(()=>{
    //             //     temps[index].status = customRed
    //             // })
    //         })

    // }

    const clickDevice = (event, mac) => {
        if (permissions.functionAction.find(value => value.function === 'Unit' && (value.isUpdate || value.isRead))) {
            history.push('/ClientDevice/' + mac)
            event.preventDefault()
        }
    }
    useEffect(() => {
        for (let i = 0; i < device.bodies.length; i++) {
            for (let j = 0; j < row.devices.length; j++) {
                if (device.bodies[i].id === row.devices[j].id) {
                    row.devices[j].status = device.bodies[i].status
                }
            }
        }
        setDevices(row.devices)

    }, [arrayData, device]);
    // useEffect(() => {
    //     setDevices(row.devices)
    //     getStatus()
    //     const interval = setInterval(getStatus, 10000);
    //     const interval = setInterval(getStatus, 15000);
    //     return () => clearInterval(interval);

    // }, [arrayData]);
    // console.log("devices devices devices devices", devices)
    return (
        <Box
            width={150}
            borderRadius="10px"
            display="flex"
            bgcolor={
                row.number
                    .toString()
                    .replace(/ /g, "")
                    .toUpperCase()
                    .indexOf(filter.replace(/ /g, "").toUpperCase()) > -1 &&
                    filter.length > 0
                    ? "#fed061"
                    : colors.orange["50"]
            }
            px={1.5}
            alignItems="center"
            style={{ textTransform: "none" }}
            component={Button}
            onClick={() =>
                roomOnClick({
                    clusterData: clusterData,
                    roomData: row,
                })
            }
        >
            {showId ? (
                <Box width="100%">
                    <Box
                        pb={1}
                        width="100%"
                        style={{ borderBottom: "1px solid #ededed" }}
                        flexGrow={1}
                        display="flex"
                        justifyItems="flex-start"
                        justifyContent="flex-start"
                        mr={3}
                    >
                        <Box flexGrow={1} display="flex">
                            <Typography className={classes.TextRoom}>{row.name}</Typography>
                        </Box>
                        <Box display="flex" alignContent="center" alignItems="center">
                            {devices.map((element, index) => (
                                <CustomTooltip
                                    onClick={(e) => clickDevice(e, element.id)}
                                    key={"toolTip" + index}
                                    arrow
                                    TransitionComponent={Zoom}
                                    placement="top"
                                    title={
                                        <React.Fragment>
                                            <Typography className={classes.TextDivices}>
                                                {element.name + "-" + element.tvModel.name}
                                            </Typography>
                                        </React.Fragment>
                                    }
                                >
                                    <Box
                                        style={{ marginRight: "4px" }}
                                        key={"dot" + index}
                                        borderRadius="50%"
                                        width="8px"
                                        height="8px"
                                        bgcolor={
                                            element.status === undefined
                                                ? customRed
                                                : element.status
                                        }
                                    ></Box>
                                </CustomTooltip>
                            ))}
                        </Box>
                    </Box>
                    <Box
                        pt={1}
                        display="flex"
                        justifyItems="flex-start"
                        justifyContent="flex-start"
                    >
                        <Typography
                            className={classes.TextID}
                            style={{ backgroundColor: "white", padding: "0 8px" }}
                        >
                            <b>ID:</b>
                            {row.number}
                        </Typography>
                    </Box>
                </Box>
            ) : (
                <Box width="100%">
                    <Box
                        py={0.5}
                        width="100%"
                        flexGrow={1}
                        display="flex"
                        justifyItems="flex-start"
                        justifyContent="flex-start"
                        mr={3}
                    >
                        <Box flexGrow={1} display="flex">
                            <Typography className={classes.TextRoom}>{row.name}</Typography>
                        </Box>
                        <Box display="flex" alignContent="center" alignItems="center">
                            {devices.map((element, index) => (
                                <CustomTooltip
                                    onClick={(e) => clickDevice(e, element.id)}
                                    key={"toolTip" + index}
                                    arrow
                                    TransitionComponent={Zoom}
                                    placement="top-start"
                                    title={
                                        <React.Fragment>
                                            <Box py={1}>
                                                <Typography className={classes.TextDivices}>
                                                    {element.name + "-" + element.tvModel.name}
                                                </Typography>
                                            </Box>
                                        </React.Fragment>
                                    }
                                >
                                    <Box
                                        mr={0.5}
                                        key={"dot" + index}
                                        borderRadius="50%"
                                        width="8px"
                                        height="8px"
                                        bgcolor={
                                            element.status === undefined
                                                ? customRed
                                                : element.status
                                        }
                                    ></Box>
                                </CustomTooltip>
                            ))}
                        </Box>
                    </Box>
                </Box>
            )}

            {/* <Box borderRadius='50%' width='10px' height='10px' bgcolor={customRed}></Box> */}
        </Box>
    );
}


const FloorItem = ({ filter, arrayData, permissions, showId, data, clusterData, roomOnClick, device }) => {
    const translate = useTranslate();
    const dataProvider = useDataProvider();
    const classes = useStyles()
    const [openChooseInfoPage, setOpenChooseInfoPage] = useState(false)
    const [infoPages, setInfoPages] = useState([])
    const [infoPageRoomLocation, setInfoPageRoomLocation] = useState([])
    const [openSpecialLocation, setOpenSpecialLocation] = useState([])
    const [uniqueSpecialLocation, setUniqueSpecialLocation] = useState([])
    const [specialLocation, setSpecialLocation] = useState('')

    const onClickSL = (index) => {
        var cloneState = cloneDeep(openSpecialLocation)
        cloneState[index] = !openSpecialLocation[index]
        setOpenSpecialLocation(cloneState)
    }

    const onCloseChooseInfoPage = (infoPage, response) => {
        let temp = infoPageRoomLocation.slice()
        if (temp.findIndex(item => item.location === data.location && specialLocation === item.specialLocation) > -1) {
            for (let i = 0; i < infoPageRoomLocation.length; i++) {
                if (clusterData.id === infoPageRoomLocation[i].cluster && infoPageRoomLocation[i].location === data.location) {
                    if (specialLocation === infoPageRoomLocation[i].specialLocation) {
                        infoPageRoomLocation[i].infoPage = infoPage.id
                    }
                }
            }
        }
        else {
            temp.push(response)
        }
        setInfoPageRoomLocation(temp)
        setOpenChooseInfoPage(false)
        setSpecialLocation('')
    }

    const openChooseInfoPageForSL = (item) => {
        setSpecialLocation(item)
        setOpenChooseInfoPage(true)
    }

    const getListInfoPage = () => {
        dataProvider('GET_LIST', 'info-page-list', {
            sort: { field: 'name', order: 'ASC' },
            pagination: { page: 0, perPage: 1 },
            filter: {}
        }).then(({ data }) => {
            setInfoPages(data)
        }
        ).catch(error => {
            console.log('error', error)
        })
    }

    const getListInfoPageRoomLocation = () => {
        dataProvider('GET_LIST', 'room-location-infopage/all', {
            sort: { field: 'name', order: 'ASC' },
            pagination: { page: 0, perPage: 1 },
            filter: {}
        }).then(({ data }) => {
            setInfoPageRoomLocation(data)
        }
        ).catch(error => {
            console.log('error', error.message)
        })
    }

    useEffect(() => {
        var arraySL = []
        data.rooms.map(item => {
            arraySL.push(item.specialLocation)
        })
        var uniqueSL = arraySL.filter(function (elem, index, self) {
            return index === self.indexOf(elem);
        })
        uniqueSL.push(uniqueSL.splice(uniqueSL.indexOf(""), 1)[0]);

        var arrayState = []
        uniqueSL.forEach(item => {
            arrayState.push(true)
        })
        setUniqueSpecialLocation(uniqueSL)
        setOpenSpecialLocation(arrayState)
        getListInfoPage()
        getListInfoPageRoomLocation()
    }, [data, device])

    return (
        <Box mx={4} my={2}>
            <DialogChooseInfoPage open={openChooseInfoPage} onClose={onCloseChooseInfoPage} data={data} clusterData={clusterData} specialLocation={specialLocation} />
            <Box display='flex' alignItems='center'>
                <Typography className={classes.floorLocation}>{data.location}</Typography>
                {/* <Button className={classes.buttonIcon} style={{ marginLeft: 8 }} color='primary' size='small' variant="contained" onClick={() => setOpenChooseInfoPage(true)}>
                    {translate(`pos.settings.infoPage`)}
                    <img src={icAlert} width={13} height={13} style={{ marginLeft: '5px' }} />
                </Button> */}
                {/* <Box ml={1} mt={0.25}>
                    <CustomTooltip arrow TransitionComponent={Zoom} placement="right" title={
                        <Box>
                            {
                                infoPageRoomLocation.map(item => {
                                    if (item.location === data.location && item.specialLocation === '') {
                                        let name = ''
                                        for (let i = 0; i < infoPages.length; i++) {
                                            if (infoPages[i].id === item.infoPage) {
                                                name = infoPages[i].name
                                            }
                                        }
                                        return <Typography style={{ lineHeight: 1.6, fontSize: 12, fontFamily: 'UniviaPro' }}>
                                            {`${translate(`resources.infoPage.infoPageName`)} ${name}`}
                                        </Typography>
                                    }

                                })
                            }
                        </Box>}
                    >
                        <IconButton size='small' onClick={() => setOpenChooseInfoPage(true)} className={classes.borderIcon} >
                            <InfoIcon style={{ width: 28, height: 28 }} />
                        </IconButton>
                    </CustomTooltip>
                </Box> */}
            </Box>
            {/* New */}
            {
                uniqueSpecialLocation.map((item, index) => {
                    if (item === "") {
                        return <Box key={index} mt={2}>
                            <Grid container
                                direction="row"
                                alignItems="center"
                                spacing={2}>
                                {
                                    data.rooms.map((row, indexRow) => {
                                        if (row.specialLocation === "")
                                            return (
                                                <Grid key={"roomNoSL" + indexRow} item>
                                                    <RoomItem filter={filter} arrayData={arrayData} row={row} permissions={permissions} showId={showId} clusterData={clusterData} roomOnClick={roomOnClick} device={device}></RoomItem>
                                                </Grid>
                                            )
                                    })
                                }
                            </Grid>
                        </Box>
                    }
                })
            }
            {
                uniqueSpecialLocation.map((item, index) => {
                    if (item !== "") {
                        return <Box key={index} ml={3} mt={1} className={classes.border} m={1} p={2.5} style={{ backgroundColor: "#c1e5fa", borderRadius: 10 }}>
                            <Box display='flex' alignItems='center' mb={0.5}>
                                <Box display='flex' onClick={() => onClickSL(index)} style={{ cursor: 'pointer', width: 'fit-content' }}>
                                    <Typography className={classes.floorLocation}>{item}</Typography>
                                    <ArrowRight fontSize='large' style={{ transform: openSpecialLocation[index] && 'rotate(90deg)', transition: 'transform 0.2s' }}></ArrowRight>
                                </Box>
                                {/* <Button className={classes.buttonIcon} style={{ marginLeft: 8, marginBottom: 12 }} color='primary' size='small' variant="contained" onClick={() => openChooseInfoPageForSL(item)}>
                                    {translate(`pos.settings.infoPage`)}
                                    <img src={icAlert} width={13} height={13} style={{ marginLeft: '5px' }} />
                                </Button> */}
                                {/* <Box ml={1} mt={0.25}>
                                    <CustomTooltip arrow TransitionComponent={Zoom} placement="right" title={
                                        <Box>
                                            {
                                                infoPageRoomLocation.map(value => {
                                                    if (value.location === data.location && value.specialLocation === item) {
                                                        let name = ''
                                                        for (let i = 0; i < infoPages.length; i++) {
                                                            if (infoPages[i].id === value.infoPage) {
                                                                name = infoPages[i].name
                                                            }
                                                        }
                                                        return <Typography style={{ lineHeight: 1.6, fontSize: 12, fontFamily: 'UniviaPro' }}>
                                                            {`${translate(`resources.infoPage.infoPageName`)} ${name}`}
                                                        </Typography>
                                                    }
                                                })
                                            }
                                        </Box>}
                                    >
                                        <IconButton size='small' onClick={() => openChooseInfoPageForSL(item)} className={classes.iconSpecial} >
                                            <InfoIcon style={{ width: 28, height: 28 }} />
                                        </IconButton>
                                    </CustomTooltip>
                                </Box> */}
                            </Box>
                            <Collapse in={openSpecialLocation[index]} timeout="auto" unmountOnExit>
                                <Grid container
                                    direction="row"
                                    alignItems="center"
                                    spacing={2}>
                                    {
                                        data.rooms.map((row, indexRow) => {
                                            if (row.specialLocation === item)
                                                return (
                                                    <Grid key={"room" + indexRow} item>
                                                        <RoomItem filter={filter} arrayData={arrayData} row={row} permissions={permissions} showId={showId} clusterData={clusterData} roomOnClick={roomOnClick} device={device}></RoomItem>
                                                    </Grid>
                                                )
                                        })
                                    }
                                </Grid>
                            </Collapse>
                        </Box>
                    }
                }
                )
            }

            {/* Old */}
            {/* <Grid container
                direction="row"
                alignItems="center"
                spacing={2}>
                {
                    data.rooms.map((row, index) => (
                        <Grid key={"room" + index} item>
                            <RoomItem filter={filter} arrayData={arrayData} row={row} permissions={permissions} showId={showId} clusterData={clusterData} roomOnClick={roomOnClick}></RoomItem>
                        </Grid>
                    ))
                }
            </Grid> */}
        </Box >
    )
}
const HeaderItem = ({ data, permissions, onClickOpenAddRoom, onClickOpenEditCluster }) => {
    const dataProvider = useDataProvider();
    const translate = useTranslate();
    const classes = useStyles();
    const popupState = usePopupState({ variant: 'popper', popupId: 'optionSend' });
    const [loading, setLoading] = useState(false);
    const [arrayData, setArrayData] = useState([]);
    const [alarmTone, setAlarmTone] = useState([]);
    const [openSendMessage, setOpenSendMessage] = useState(false);
    const [openSendAlarm, setOpenSendAlarm] = useState(false);
    const [receiver, setReceiver] = useState();
    const [dialogSuccessMessage, setDialogSuccessMessage] = useState('');

    const theme = useSelector((state) =>
        state.theme === 'dark' ? darkTheme : lightTheme
    );

    const getListRoom = () => {
        const clusterID = data.id
        setLoading(true)
        dataProvider('GET_LIST', "room/assign", {
            filter: {
            },
            pagination: {},
            sort: { field: 'name', order: 'ASC' },

        })
            .then(({ data }) => {
                var listRoom = []
                data.listRoom.map(room => {
                    if (room.cluster.id === clusterID) {
                        listRoom.push(room)
                    }
                })

                var temp = []
                listRoom.map(room => {
                    room.clusterMessage = true;
                    room.name += ` - ID: ${room.number}`
                    temp.push(room)
                })

                var group = [
                    {
                        name: temp[0].cluster.name,
                        rooms: temp
                    }
                ]
                setArrayData(group)
                setLoading(false)
            })
            .catch(error => {
                setLoading(false)
            })
    }

    const getListToneAlarm = () => {
        setLoading(true)
        dataProvider('GET_LIST', "category/audio", {
            filter: {},
            pagination: {},
            sort: {},
        }).then(response => {
            setAlarmTone(response.data)
            setLoading(false)
        }).catch(error => {
            setLoading(false)
        })
    }

    const selectToMessageItem = (value) => {
        popupState.close()
        setReceiver(value)
        setLoading(true)
        getListRoom()
        setOpenSendMessage(true)
    }

    const selectToAlarmItem = (value) => {
        popupState.close()
        setReceiver(value)
        setLoading(true)
        getListRoom()
        getListToneAlarm()
        setOpenSendAlarm(true)
    }

    const onCloseDialogMessage = (type) => {
        setOpenSendMessage(false)
        setArrayData([]);
        onShowSuccessDialog(type, true);
    }

    const onCloseDialogAlarm = (type) => {
        setOpenSendAlarm(false);
        setArrayData([]);
        onShowSuccessDialog(type, false);
    }

    const onShowSuccessDialog = (type, sendMessage = false) => {
        if (!type) return;
        if (sendMessage) {
            switch (type) {
                case MESSAGES_TYPE.DRAFT:
                    setDialogSuccessMessage(translate('resources.messages.draftSuccess'));
                    break;
                case MESSAGES_TYPE.SCHEDULED:
                    setDialogSuccessMessage(translate('resources.messages.scheduleSuccess'));
                    break;
                case MESSAGES_TYPE.SENT:
                    setDialogSuccessMessage(translate('resources.messages.sentSuccess'));
                    break;
                default:
                    break;
            }
        } else {
            switch (type) {
                case MESSAGES_TYPE.DRAFT:
                    setDialogSuccessMessage(translate('resources.alarm.draftSuccess'));
                    break;
                case MESSAGES_TYPE.SCHEDULED:
                    setDialogSuccessMessage(translate('resources.alarm.scheduleSuccess'));
                    break;
                case MESSAGES_TYPE.SENT:
                    setDialogSuccessMessage(translate('resources.alarm.sentSuccess'));
                    break;
                default:
                    break;
            }
        }
    }

    // TODO: Open create form dialog

    return (
        <Box className={classes.border} m={1} mb={1.5} p={2.5}>
            <Grid container
                direction="row"
                justify="space-between"
                alignItems="center"
                spacing={1}>
                <Grid item>
                    <Box>
                        <Grid container spacing={1} style={{ margin: 0 }}>
                            {
                                (permissions.functionAction.find(value => value.function === 'Cluster settings' && value.isRead)
                                    || permissions.functionAction.find(value => value.function === 'CRUD Cluster' && value.isRead)) &&
                                <Grid item>
                                    <Button className={classes.buttonIcon} color='primary' size='small' variant="contained" onClick={() => onClickOpenEditCluster(0)}>
                                        {translate(`resources.room.edit`)}
                                        <img src={icConfig} width={13} height={13} style={{ marginLeft: '5px' }} />
                                    </Button>
                                </Grid>
                            }
                            {
                                permissions.functionAction.find(value => value.function === 'Room settings' && value.isCreate) &&
                                (
                                    <Grid item>
                                        <Button className={classes.buttonIcon} color='primary' size='small' variant="contained" onClick={onClickOpenAddRoom}>
                                            {translate(`resources.room.addNewRoom`)}
                                            <img src={icWindowApp} width={13} height={13} style={{ marginLeft: '5px' }} />
                                        </Button>
                                    </Grid>
                                )
                            }
                            {
                                (permissions.functionAction.find(value => value.function === 'Cluster settings' && value.isUpdate)
                                    && permissions.functionAction.find(value => value.function === 'Cluster Info Channel Admin' && value.isRead)) &&
                                <Grid item>
                                    <Button onClick={() => onClickOpenEditCluster(3)} className={classes.buttonIcon} color='primary' size='small' variant="contained" >
                                        {translate(`resources.room.infoChannel`)}
                                        <img src={icAlert} width={13} style={{ marginLeft: '5px' }} />
                                    </Button>
                                </Grid>
                            }
                            {
                                permissions.functionAction.find(value => value.function === 'Client devices' && value.isRead) &&
                                <Grid item>
                                    <Button className={classes.buttonIcon} color='primary' size='small' variant="contained" component={Link} to={"/ClientDevice"}>
                                        {translate(`resources.room.devices`)}
                                        <img src={icScreen} width={13} style={{ marginLeft: '5px' }} />
                                    </Button>
                                </Grid>
                            }
                            {
                                permissions.functionAction.find(value => value.function === 'Cluster messages' && value.isUpdate) ||
                                    permissions.functionAction.find(value => value.function === 'Cluster Alarms' && value.isUpdate) ?
                                    (
                                        <Grid item>
                                            <Button className={classes.buttonIcon} color='primary' size='small' variant="contained" {...bindToggle(popupState)}>
                                                {translate(`resources.room.send`)}
                                                <img src={icEmail} width={13} style={{ marginLeft: '5px' }} />
                                            </Button>
                                            <CustomPopoverArrow
                                                zIndex={2}
                                                disablePortal={true}
                                                popupState={popupState}
                                                placement='right-start'
                                            >
                                                <Paper style={{ padding: '8px 16px' }}>
                                                    <List component="nav" aria-label="main mailbox folders">
                                                        {
                                                            permissions.functionAction.find(value => value.function === 'Cluster messages' && value.isUpdate) && (
                                                                <ListItem button onClick={() => selectToMessageItem('Individuals')}>
                                                                    <Typography className={classes.textTab}>{translate(`resources.messages.sendMessageCluster`)}</Typography>
                                                                </ListItem>

                                                            )
                                                        }
                                                        {
                                                            permissions.functionAction.find(value => value.function === 'Cluster Alarms' && value.isUpdate) && (
                                                                <ListItem button onClick={() => selectToAlarmItem('Individuals')}>
                                                                    <Typography className={classes.textTab}>{translate(`resources.alarm.sendAlarmCluster`)}</Typography>
                                                                </ListItem>
                                                            )
                                                        }

                                                    </List>
                                                    <Box width='100%' display='flex' justifyContent='flex-end'>
                                                        <Button onClick={popupState.close} size='small' color='primary'>{translate(`resources.room.close`)}</Button>
                                                    </Box>

                                                </Paper>
                                            </CustomPopoverArrow>
                                        </Grid>
                                    ) : null
                            }

                        </Grid>
                    </Box>


                </Grid>
                <Grid item>
                    <Box>
                        <Grid container spacing={2} style={{ margin: 0 }}>
                            <Grid item>
                                <Box display='flex' alignItems='center'>
                                    <Box borderRadius='50%' width='10px' mr='5px' height='10px' bgcolor={paleOlive}></Box>
                                    <Typography className={classes.TextIcon}>{translate(`resources.room.tv`)}</Typography>
                                </Box>
                            </Grid>
                            <Grid item>
                                <Box display='flex' alignItems='center'>
                                    <Box borderRadius='50%' width='10px' mr='5px' height='10px' bgcolor={greyBlue}></Box>
                                    <Typography className={classes.TextIcon}>{translate(`resources.room.vod`)}</Typography>
                                </Box>
                            </Grid>
                            <Grid item>
                                <Box display='flex' alignItems='center'>
                                    <Box borderRadius='50%' width='10px' mr='5px' height='10px' bgcolor={customRed}></Box>
                                    <Typography className={classes.TextIcon}>{translate(`resources.room.offline`)}</Typography>
                                </Box>
                            </Grid>
                            <Grid item>
                                <Box display='flex' alignItems='center'>
                                    <Box borderRadius='50%' width='10px' mr='5px' height='10px' bgcolor={turQuoise}></Box>
                                    <Typography className={classes.TextIcon}>{translate(`resources.room.menu`)}</Typography>
                                </Box>
                            </Grid>
                            <Grid item>
                                <Box display='flex' alignItems='center'>
                                    <Box borderRadius='50%' width='10px' mr='5px' height='10px' bgcolor={darkFuchsia}></Box>
                                    <Typography className={classes.TextIcon}>{translate(`resources.room.infoChannel`)}</Typography>
                                </Box>
                            </Grid>
                        </Grid>
                    </Box>
                </Grid>
            </Grid>
            <CreateMessageDialog
                open={openSendMessage}
                loadingDialog={loading}
                onClose={onCloseDialogMessage}
                receiver={receiver}
                data={arrayData}
                recipientData={[]}
                repSubject={null}        // get latest message subject
                thread={null}
                isInCluster={true}
            />
            <CreateAlarmDialog
                open={openSendAlarm}
                loadingDialog={loading}
                alarmToneData={alarmTone}
                onClose={onCloseDialogAlarm}
                receiver={receiver}
                data={arrayData}
                isInCluster={true}
            />
            <DialogSendSuccess
                open={dialogSuccessMessage.length > 0}
                onClose={() => setDialogSuccessMessage('')}
                message={dialogSuccessMessage}
            />
        </Box>
    )

}

const ClusterItem = ({ filter, openEditRoom, showId, permissions, openCreate, isExpand, handleClick, data, onClickOpenAddRoom, onClickOpenEditCluster, onClickOpenEditRoom, index, ...props }) => {
    const dataProvider = useDataProvider();
    const translate = useTranslate();
    const [arrayData, setArrayData] = useState([])
    const [notPermission, setNotPermission] = useState(false)
    const theme = useSelector((state) =>
        state.theme === 'dark' ? darkTheme : lightTheme
    );
    const [randomNumber, setRandomNumber] = useState(Math.random());
    const [device, setDevice] = useState({
        bodies: [],
        sortable: { field: 'name', order: 'ASC' },
    });
    // const handleClick = () => {
    //     console.log(index)
    //     setOpen(!open)
    // }

    const getListDevices = () => {
        let filter = {
        }

        dataProvider('GET_LIST', "devices", {
            filter,
            pagination: {
                page: 0,
                perPage: 1
            },
            sort: { field: 'name', order: 'ASC' }
        }).then(({ data, total }) => {
            //console.log('Get list success:', data);
            let devices = data.map(item => ({
                ...item,
                checked: false,
                status: item.status === 1 ? translate(`pos.common.online`) : translate(`pos.dashboard.offline`),
                green: item.status,
                red: !item.status,
                // room: item.roomCluster
            }));
            setDevice({
                ...device,
                bodies: devices
            });
        }).catch(error => {
            console.error('Get list error:', error);
        })
    }



    const getStatus = () => {
        if (device.bodies) {
            const temps = device.bodies.slice();
            const arrayMac = [];
            device.bodies.forEach((value) => {
                arrayMac.push(value.id)
            });

            if (arrayMac.length > 0) {
                dataProvider('CREATE', "devices/getstatus", {
                    data: {
                        macs: arrayMac
                    }
                }).then(({ data }) => {
                    data.forEach((item, index) => {
                        switch (item.status) {
                            case 1:
                                temps[index].status = customRed
                                break;
                            case 2://VOD
                                temps[index].status = greyBlue
                                break;
                            case 3://TV
                                temps[index].status = paleOlive
                                break;
                            case 4://Menu
                                temps[index].status = turQuoise
                                break;
                            case 5://IC
                                temps[index].status = darkFuchsia
                                break;

                            default:
                                temps[index].status = customRed

                        }

                    });
                    setDevice({
                        ...device,
                        bodies: temps
                    });
                });
            }
        }
    }

    useEffect(() => {
        getStatus();
        if (!_intervalUpdateStatus)
            _intervalUpdateStatus = setInterval(() => {
                setRandomNumber(Math.random());
            }, 10000);
        return () => {
            if (_intervalUpdateStatus) {
                clearInterval(_intervalUpdateStatus);
                _intervalUpdateStatus = null;
            }
        };
    }, [randomNumber]);


    useEffect(() => {
        getListDevices()
    }, [])
    // const handleClick = () => {
    //     console.log(index)
    //     setOpen(!open)
    // }
    function compare(a, b) {
        if (a.location < b.location) {
            return -1;
        }
        if (a.location > b.location) {
            return 1;
        }
        return 0;
    }
    useEffect(() => {

        dataProvider('GET_LIST', "room", {
            filter: {
                cluster: parseInt(data.id)
            },
            pagination: {},
            sort: { field: 'name', order: 'ASC' },

        })
            .then(({ data }) => {

                let floors = data.reduce((r, a) => {
                    r[a.location] = [...r[a.location] || [], a]
                    return r;
                }, {})
                var tempArray = Object.keys(floors).map((key) => {
                    return {
                        location: key,
                        rooms: floors[key]
                    }
                })
                setArrayData(tempArray)

            })
            .catch(() => {
                setNotPermission(true)

            })
    }, [openCreate, onClickOpenEditRoom]);
    return (
        <SubItem
            subColor={theme.palette.primary.main}
            name={data.name}
            open={isExpand}
            handleClick={() => handleClick(index)}>
            <List component="div" disablePadding>
                <HeaderItem data={data} permissions={permissions} onClickOpenAddRoom={() => onClickOpenAddRoom(data)} onClickOpenEditCluster={onClickOpenEditCluster(data, index)} />
                {
                    !permissions.functionAction.find(value => value.function === 'Room settings' && (value.isRead || value.isUpdate)) || notPermission ?
                        (
                            <Box textAlign='center' p={2}>
                                <Typography variant='h2' style={{ fontFamily: 'Roboto, sans-serif', color: 'grey' }}>{translate(`resources.room.noPermission`)}</Typography>
                            </Box>
                        )
                        :
                        arrayData.sort(compare).map((row, index) => (
                            <Box key={"floor" + index}>
                                <FloorItem filter={filter} arrayData={arrayData} showId={showId} permissions={permissions} data={row} clusterData={data} roomOnClick={onClickOpenEditRoom} device={device} />
                            </Box>

                        ))
                }
            </List>
        </SubItem>)
}


const ClusterContainer = ({ filter, openEditRoom, showId, permissions, openCreate, data, onClickOpenAddRoom, onClickOpenEditCluster, onClickOpenEditRoom, openExpands, clickExpand, ...props }) => {
    const translate = useTranslate();
    const classes = useStyles();

    return (
        <Box>
            <ClusterItem
                index={0}
                showId={showId}
                isExpand={openExpands[0]}
                handleClick={clickExpand}
                data={data.cluster.find(element => element.id == props.match.params.id)}
                onClickOpenAddRoom={onClickOpenAddRoom}
                onClickOpenEditCluster={onClickOpenEditCluster}
                onClickOpenEditRoom={onClickOpenEditRoom}
                permissions={permissions}
                openCreate={openCreate}
                openEditRoom={openEditRoom}
                filter={filter}
            />
            {
                data.cluster.filter(value =>
                    value.group == data.cluster.find(element => element.id == props.match.params.id).group
                    && value.entity == data.cluster.find(element => element.id == props.match.params.id).entity
                    && value.id != props.match.params.id).length > 0 &&
                (<Box mt={5}>
                    <Typography className={classes.group}>{translate(`resources.room.inSameGroup`)}</Typography>
                </Box>)
            }

            {
                data.cluster.filter(value =>
                    value.group == data.cluster.find(element => element.id == props.match.params.id).group
                    && value.entity == data.cluster.find(element => element.id == props.match.params.id).entity
                    && value.id != props.match.params.id).map((row, index) => (
                        <ClusterItem
                            filter={filter}
                            key={index}
                            index={index + 1}
                            showId={showId}
                            isExpand={openExpands[index + 1]}
                            handleClick={clickExpand}
                            permissions={permissions}
                            data={row}
                            onClickOpenEditRoom={onClickOpenEditRoom}
                            onClickOpenAddRoom={onClickOpenAddRoom}
                            onClickOpenEditCluster={onClickOpenEditCluster}
                            openCreate={openCreate}
                        />

                    ))
            }

        </Box>



    )

}

const Room = (props) => {
    const translate = useTranslate();
    const classes = useStyles();
    const [filter, setFilter] = useState("");
    const [data, setData] = useState(null);
    const [isExpanAll, setIsExpanAll] = useState(false);
    const [showRoomId, setShowRoomId] = useState(false);
    const [loading, setLoading] = useState(true);
    const dataProvider = useDataProvider();
    const isDesktop = useMediaQuery(theme => theme.breakpoints.up('md'));
    const [openCreate, setOpenCreate] = useState(false)
    const [openBackDrop, setOpenBackDrop] = useState(false)
    const [openEditCluster, setOpenEditCluster] = useState(false)
    const [openEditRoom, setOpenEditRoom] = useState(false)
    const [openExpands, setOpenExpands] = useState([true])
    const [editData, setEditData] = useState({})
    const [editRoomData, setEditRoomData] = useState({})
    const [editIndex, setEditIndex] = useState({})
    const [valueAddRoom, setValueAddRoom] = useState({})
    const [openDialogAlert, setOpenDialogAlert] = useState(false);
    const [isCloseEdit, setIsCloseEdit] = useState(false)
    const { permissions, loaded } = usePermissions();
    const [deleted, setDeleted] = useState();
    const [isChange, setIsChange] = useState(false)
    const [openDialogAlertInRoom, setOpenDialogAlertInRoom] = useState(false);
    const [isChangeInRoom, setIsChangeInRoom] = useState(false)
    const [isCloseEditInRoom, setIsCloseEditInRoom] = useState(false)
    const [error, setError] = useState();
    const theme = useSelector((state) =>
        state.theme === 'dark' ? darkTheme : lightTheme
    );
    const location = useLocation();

    useEffect(() => {
        dataProvider('GET_LIST', "ClusterAssign", {
            filter: {
            },
            pagination: {},
            sort: { field: 'name', order: 'ASC' },

        })
            .then(({ data }) => {
                setData(data);
                setLoading(false);
            })
            .catch(error => {
                setError(error);
                setLoading(false);
            })

    }, [openEditCluster]);

    useEffect(() => {
        if (location.state) {
            setFilter(location.state.keyFilter.toString());
        }
    }, [location]);

    // if (deleted !== undefined) return (
    //     <Box width={500} margin='auto' p={2} mt={10} textAlign='center'>

    //         <Box alignContent='center'>
    //             <DoneOutline style={{ color: 'green', fontSize: '5em' }}></DoneOutline>
    //             <Typography variant="h4">{`Great job! ${deleted.name} deleted!`}</Typography>
    //             <Button
    //                 color='primary'
    //                 size='large'
    //                 component='a'
    //                 href='/'
    //                 style={{ marginTop: '16px' }}>Back Home </Button>

    //         </Box>

    //     </Box>

    // )


    const handleClick = (index) => {
        let tempArray = openExpands.slice()
        tempArray[index] = !tempArray[index]
        setOpenExpands(tempArray)
    }



    const onChangeExpanAll = (event) => {
        setIsExpanAll(!isExpanAll)
        var tempsArray = []
        for (let i = 0; i < data.cluster.length; i++) {
            if (data.cluster[i].group == data.cluster.find(value => value.id == props.match.params.id).group
                && data.cluster[i].entity == data.cluster.find(value => value.id == props.match.params.id).entity)
                tempsArray.push(event.target.checked)
        }
        setOpenExpands(tempsArray)

    }

    const onChangeShowRoomId = () => {
        setShowRoomId(!showRoomId)

    }

    const searchOnChange = (e) => {
        setFilter(e.target.value)
    }


    const onClickAddRoom = (element) => {
        setValueAddRoom(element)
        setOpenCreate(true)
    }


    const handelCloseDialog = () => {
        setOpenCreate(false)
    }


    const onClickEditCluster = (element, index) => (tabIndex) => {
        element.tabIndex = tabIndex
        setEditData(element)
        setEditIndex(index)
        setOpenEditCluster(true)
    }

    const handelCloseDialogEditCluster = () => {
        if (isChange === true) {
            setOpenDialogAlert(true)
            setIsCloseEdit(true)
        }
        else
            setOpenEditCluster(false)
    }

    const onClickEditRoom = (element) => {
        console.log(element)
        setEditRoomData(element)
        setOpenEditRoom(true)
    }

    const handelCloseDialogEditRoom = () => {
        if (isChangeInRoom === true) {
            setOpenDialogAlertInRoom(true)
            setIsCloseEditInRoom(true)
        }
        else
            setOpenEditRoom(false)
    }
    useEffect(() => {
        if (isCloseEdit === false)
            setOpenEditCluster(false)
    }, [isCloseEdit])

    if (loading || !loaded) return <Loading />;
    if (!data) return null;
    if (data.cluster.find(element => element.id == props.match.params.id) === undefined) return <Error></Error>;

    return (
        !permissions.functionAction.find(value => value.function === 'Cluster settings' && (value.isUpdate || value.isRead)) ?
            <Box width='100%' >
                <Box width={!isDesktop ? '95%' : '80%'} m='auto'>
                    <Box my={2}>
                        <Box my={5} width={300}
                            display='flex'
                            component={Link}
                            to={{ pathname: "/Entity/" + encodeURIComponent(data.cluster.find(element => element.id == props.match.params.id).entity) } }
                            style={{ textDecoration: 'none' }}>
                            <Box display='flex' mr={2}>
                                <GoBackButton color={theme.squareButon.content} />
                            </Box>
                            <Typography
                                className={classes.HeaderBack}
                                style={{ margin: 'auto 0' }}>
                                {data.cluster.find(element => element.id == props.match.params.id).entity}
                            </Typography>
                        </Box>
                        <Box textAlign='center' p={2}>
                            <Typography variant='h2' style={{ fontFamily: 'UniviaPro', color: 'grey' }}>{translate(`pos.cluster.noPermission`)}</Typography>
                        </Box>
                    </Box>
                </Box>
            </Box>
            :
            <Box width='100%' >
                <Title title={data.cluster.find(element => element.id == props.match.params.id).group} />
                <Box width={!isDesktop ? '95%' : '80%'} m='auto'>
                    <Box my={2}>
                        <Box my={5} width={300}
                            display='flex'
                            component={Link}
                            to={{ pathname: "/Entity/" + encodeURIComponent(data.cluster.find(element => element.id == props.match.params.id).entity) } }
                            style={{ textDecoration: 'none' }}>
                            <Box display='flex' mr={2}>
                                <GoBackButton color={theme.squareButon.content} />
                            </Box>
                            <Typography
                                className={classes.HeaderBack}
                                style={{ margin: 'auto 0' }}>
                                {data.cluster.find(element => element.id == props.match.params.id).entity}
                            </Typography>
                        </Box>
                        <Grid container direction="row" alignItems="center" justify="space-between" spacing={1}>
                            <Grid item>
                                <Typography className={classes.group}>
                                    {data.cluster.find(element => element.id == props.match.params.id).group}
                                </Typography>
                            </Grid>
                            <Grid item >
                                <Box display='flex' alignItems='center' justifyItems='flex-end'>
                                    <Grid container spacing={3}>
                                        <Grid item>
                                            <Box borderRadius='10px' style={{ border: 'solid 1px #e0f0f2' }} >
                                                <Paper component="form" className={classes.searchPaper}>
                                                    < img src={icSearch} width={17.6} height={17.6} style={{ marginLeft: '10.7px' }}></img>
                                                    <InputBase
                                                        placeholder={translate(`resources.room.search`)}
                                                        inputProps={{
                                                            'aria-label': 'search',
                                                            className: classes.input
                                                        }}
                                                        value={filter}
                                                        onChange={searchOnChange} />
                                                </Paper>
                                            </Box>
                                        </Grid>
                                        <Grid item style={{ display: 'flex' }}>
                                            <Grid container>
                                                <Grid item style={{ marginRight: '20px' }}>
                                                    <Box width={173} height={30} borderRadius='4px' justifyContent='center' display="flex" bgcolor='#ffffff' alignItems='center'>
                                                        <Typography className={classes.textExpand} >
                                                            {translate(`resources.room.expandAll`).toUpperCase()}
                                                        </Typography>
                                                        <GreenSwitch
                                                            size='small'
                                                            checked={isExpanAll}
                                                            onChange={onChangeExpanAll}
                                                        ></GreenSwitch>
                                                    </Box>
                                                </Grid>
                                                <Grid item>
                                                    <Box width={145} height={30} borderRadius='4px' justifyContent='center' px={1} display="flex" bgcolor='#ffffff' alignItems='center'>
                                                        <Typography className={classes.textExpand} >
                                                            {translate(`resources.room.showRoomId`).toUpperCase()}
                                                        </Typography>
                                                        <GreenSwitch
                                                            size='small'
                                                            checked={showRoomId}
                                                            onChange={onChangeShowRoomId}></GreenSwitch>
                                                    </Box>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Box>
                            </Grid>
                        </Grid>
                    </Box>
                    <Box>
                        <ClusterContainer
                            filter={filter}
                            openExpands={openExpands}
                            clickExpand={handleClick}
                            openEditRoom={openEditRoom}
                            data={data}
                            showId={showRoomId}
                            openCreate={openCreate}
                            {...props}
                            permissions={permissions}
                            onClickOpenAddRoom={onClickAddRoom}
                            onClickOpenEditCluster={onClickEditCluster}
                            onClickOpenEditRoom={onClickEditRoom}
                        />
                    </Box>
                </Box>
                <CreateRoomDialog
                    open={openCreate}
                    handleClose={handelCloseDialog}
                    dataRecever={data}
                    clusterData={valueAddRoom}

                    {...props}
                />
                <EditClusterDialog
                    readOnly={!permissions.functionAction.find(value => value.function === 'CRUD Cluster' && value.isUpdate)}
                    setDeleted={setDeleted}
                    open={openEditCluster}
                    handleClose={handelCloseDialogEditCluster}
                    dataRecever={data}
                    openDialogAlert={openDialogAlert}
                    setOpenDialogAlert={setOpenDialogAlert}
                    isChange={isChange}
                    setIsChange={setIsChange}
                    isCloseEdit={isCloseEdit}
                    setIsCloseEdit={setIsCloseEdit}
                    setEditData={setEditData}
                    tabIndex={editData.tabIndex}
                    clusterData={editData}
                    {...props}
                />
                <EditRoomDialog
                    readOnly={!permissions.functionAction.find(value => value.function === 'Room settings' && value.isUpdate)}
                    open={openEditRoom}
                    handleClose={handelCloseDialogEditRoom}
                    data={editRoomData}
                    openDialogAlertInRoom={openDialogAlertInRoom}
                    setOpenDialogAlertInRoom={setOpenDialogAlertInRoom}
                    isChangeInRoom={isChangeInRoom}
                    setIsChangeInRoom={setIsChangeInRoom}
                    isCloseEditInRoom={isCloseEditInRoom}
                    setIsCloseEditInRoom={setIsCloseEditInRoom}
                    {...props}
                />

                <Backdrop className={classes.backdrop} open={openBackDrop}>
                    <CircularProgress color="inherit" />
                </Backdrop>
            </Box>
    )

}
export default Room

